import { useQuery } from "@tanstack/react-query"
import { conversationMessageCapabilityExecutionsQuery } from "../lib/conversationMessageCapabilityExecutionsQuery"

export function useConversationMessageCapabilityExecutionsQuery(
  ...args: Parameters<typeof conversationMessageCapabilityExecutionsQuery>
) {
  return useQuery(conversationMessageCapabilityExecutionsQuery(...args))
}
